"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _miniPackages = _interopRequireDefault(require("./miniPackages.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _default(window, requirejs, isBot, experiment) {
  var document = window.document;
  var _window$performance = window.performance,
      performance = _window$performance === void 0 ? {} : _window$performance;

  if (!performance.measure) {
    performance = {
      mark: function mark() {},
      measure: function measure() {}
    };
  }

  function notifyParent(msg) {
    try {
      window.parent.postMessage(msg, '*');
    } catch (e) {//ignore
    }
  }

  notifyParent('santaStart');

  function render(isServerSide, isPreview, isExternalPreview, _ref, queryUtil, siteModel, wixBiSession, mobileView, config) {
    var contentCache = _ref.contentCache,
        setContext = _ref.setContext,
        prefetchResources = _ref.prefetchResources,
        preconnectAssetsServer = _ref.preconnectAssetsServer,
        preloadScripts = _ref.preloadScripts;
    var useDS = queryUtil.isParameterTrue('ds');
    var selectiveCompsDS = queryUtil.isParameterTrue('selectiveCompsDS');
    var isQaAutomation = queryUtil.isParameterTrue('isqa');
    var isTpaIntegration = queryUtil.isParameterTrue('isTpaIntegration');
    var isWixCodeIntegration = queryUtil.isParameterTrue('isWixCodeIntegration');
    var isViewerIntegration = queryUtil.isParameterTrue('isViewerIntegration');
    var isAppStudioWithDSIntegration = queryUtil.getParameterByName('configName') === 'appStudio';
    siteModel.requestModel = {
      userAgent: window.navigator.userAgent,
      cookie: document.cookie
    }; //eslint-disable-next-line no-extra-parens

    var hasProtectedPages = function (_ref2) {
      var _ref2$rendererModel = _ref2.rendererModel,
          _ref2$rendererModel$p = _ref2$rendererModel.passwordProtectedPages,
          passwordProtectedPages = _ref2$rendererModel$p === void 0 ? [] : _ref2$rendererModel$p,
          _ref2$rendererModel$p2 = _ref2$rendererModel.pageList;
      _ref2$rendererModel$p2 = _ref2$rendererModel$p2 === void 0 ? {} : _ref2$rendererModel$p2;
      var _ref2$rendererModel$p3 = _ref2$rendererModel$p2.pages,
          pages = _ref2$rendererModel$p3 === void 0 ? [] : _ref2$rendererModel$p3;
      return passwordProtectedPages.length || pages.some(function (page) {
        return !page.pageJsonFileName;
      });
    }(siteModel);

    function addConditionalDependencies(pkgs) {
      function isQuickActionEnabled(quickActionName) {
        var _siteModel$rendererMo = siteModel.rendererModel.siteMetaData;
        _siteModel$rendererMo = _siteModel$rendererMo === void 0 ? {} : _siteModel$rendererMo;
        var _siteModel$rendererMo2 = _siteModel$rendererMo.quickActions;
        _siteModel$rendererMo2 = _siteModel$rendererMo2 === void 0 ? {} : _siteModel$rendererMo2;
        var _siteModel$rendererMo3 = _siteModel$rendererMo2.configuration,
            configuration = _siteModel$rendererMo3 === void 0 ? {} : _siteModel$rendererMo3;
        return !!configuration[quickActionName];
      }

      if (useDS || isPreview) {
        pkgs.push('documentServices-santa', 'document-services-schemas');
        siteModel.loadDocumentServices = true;
      }

      if (isPreview) {
        pkgs.push('immutable');
      }

      if (hasProtectedPages) {
        pkgs.push('dialogs', 'linkBar', 'loginSocialBar', 'controller');

        if (isServerSide) {
          pkgs.push('backToTopButton');
        }
      }

      if (mobileView) {
        pkgs.push('tinyMenu', 'loginSocialBar', 'icon', 'svgShape', 'quickActionBar');

        if (isQuickActionEnabled('quickActionsMenuEnabled')) {
          pkgs.push('mobileActionsMenu');
        }
      }

      if (isPreview || siteModel.rendererModel.siteInfo.documentType === 'Template') {
        pkgs.push('translationsUtils');
      }

      return pkgs;
    }

    var handleRequireError = function handleRequireError(pkgs) {
      return function (err) {
        if (err.requireType === 'define') {
          requirejs.onError(err);
          return;
        }

        if (!config.urlArgs) {
          if (err.requireModules) {
            err.requireModules.forEach(function (module) {
              requirejs.undef(module);
            });
          }

          config.urlArgs = "c=".concat(Date.now());
          requirejs.config(config);
          var errClone = Object.keys(err).reduce(function (r, k) {
            r[k] = err[k];
            return r;
          }, {});
          errClone.message = err.message;
          errClone.stack = err.stack ? '' + err.stack : ''; //eslint-disable-line prefer-template

          requirejs(pkgs, function () {
            errClone.errn = 'REQUIREJS_RETRY_ERROR';
            errClone.errc = 111025;
            errClone.severity = 10;
            requirejs.onError(errClone);
          }, requirejs.onError);
        }
      };
    };

    var buildFunctionParametersObject = function buildFunctionParametersObject(pkgs, args) {
      return pkgs.reduce(function (result, pkg, index) {
        result[pkg] = args[index];
        return result;
      }, {});
    };

    var loadRequirements = function loadRequirements(pkgs, cb) {
      var loaded = cb ? function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var p = buildFunctionParametersObject(pkgs, args);
        cb(p);
      } : function () {};

      if (queryUtil.getParameterByName('debug')) {
        requirejs(pkgs, loaded);
      } else {
        requirejs(pkgs, loaded, handleRequireError(pkgs));
      }
    };

    var load = function load(pkgs, cb) {
      wixBiSession.packagesLoaded = Date.now();
      /*
       * Require all needed packages (static + conditional)
       * Then do initial site render (or re-layout if it was rendered by the server)
       */

      function getAjaxHandler($, cookieUtils) {
        var ignore = {};

        var canUseCache = function canUseCache(_ref3) {
          var url = _ref3.url,
              type = _ref3.type,
              timeout = _ref3.timeout;
          return !ignore[url] && (!type || type.toUpperCase() === 'GET') && !timeout;
        };

        function addXSRFHeader(options) {
          var XSRFToken = cookieUtils.getCookie('XSRF-TOKEN');

          if (XSRFToken) {
            options.headers = options.headers || {};
            options.headers['X-XSRF-TOKEN'] = XSRFToken;
          }
        }

        function getHostname(url) {
          return url.match(/:\/\//) !== undefined ? url.split('/')[2] : url.split('/')[0];
        }

        return function (options) {
          if (options.cache !== false && canUseCache(options) && contentCache(options)) {
            return;
          }

          ignore[options.url] = true;

          if (options.type === 'POST' && getHostname(options.url) === 'editor.wix.com') {
            addXSRFHeader(options);
          }

          $.ajax.apply($, arguments);
        };
      }

      loadRequirements([].concat(_toConsumableArray(pkgs), ['warmupUtils', 'zepto']), function (p) {
        var ajaxHandler = getAjaxHandler(p.zepto, p.warmupUtils.cookieUtils);
        p.warmupUtils.ajaxLibrary.register(ajaxHandler);

        if (siteModel.wixData) {
          var siteStructureNode = document.getElementById('masterPage') || document.getElementById('SITE_STRUCTURE');
          siteModel.wixHtmlRaw = siteStructureNode.outerHTML;
          siteModel.wixAnchors = window.anchors || {};
          siteStructureNode.parentNode.removeChild(siteStructureNode);
        }

        siteModel.requestModel.storage = p.warmupUtils.storage(window);
        siteModel.currentUrl = p.warmupUtils.urlUtils.parseUrl(window.serverSideUrl || window.location.href);
        siteModel.forceMobileView = window.forceMobileView;
        cb(p, ajaxHandler);
      });
    };

    var loadWithIntegrationPackages = function loadWithIntegrationPackages(_, pkgs, cb) {
      var addIntegrationPackages = function addIntegrationPackages(packages) {
        if (isQaAutomation) {
          packages.push('qaAutomation');
        }

        if (isTpaIntegration) {
          packages.push('tpaIntegration', 'jasmine', 'jasmine-html');
        }

        if (isWixCodeIntegration) {
          packages.push('wixCodeIntegration', 'jasmine', 'jasmine-html');
        }

        if (isViewerIntegration) {
          packages.push('viewerIntegration', 'jasmine', 'jasmine-html');
        }

        return _.uniq(packages);
      };

      var initIntegrationPackages = function initIntegrationPackages(p) {
        var tpaIntegration = p.tpaIntegration,
            wixCodeIntegration = p.wixCodeIntegration,
            viewerIntegration = p.viewerIntegration;

        if (tpaIntegration) {
          tpaIntegration.init(window, p.componentsCore);
        }

        if (wixCodeIntegration) {
          wixCodeIntegration.init(window, p.componentsCore, p.wixCode, p['host-platform-api'], p.utils, p.tpa);
        }

        if (viewerIntegration) {
          viewerIntegration.init(window, p.componentsCore, p.utils);
        }
      };

      loadRequirements(addIntegrationPackages(pkgs), function (p) {
        initIntegrationPackages(p);
        cb(p);
      });
    };

    function getClientSidePackages() {
      var clientSidePackages = ['santa-animations', 'backgroundCommon', 'buttonCommon', 'color', 'compDesignUtils', 'components', 'compUtils', 'core', 'componentsCore', 'coreMultilingual', 'coreUtils', 'coreUtilsLib', 'create-react-class', 'data-capsule', 'dataFixer', 'displayer', 'fedops-logger', 'formCommon', 'galleriesCommon', 'host-platform-api', 'image-client-api', 'imageZoom', 'layout', 'mobileLayoutUtils', 'mobileLayoutUtils', 'mobx', 'mobx-react', 'platformUtils', 'pmrpc', 'prop-types', 'react', 'react-dom-factories', 'reactDOM', 'render', 'santa-components', 'santa-data-fixer', 'santaProps', 'ScrollToPlugin', 'site-widgets', 'skinExports', 'skins', 'skinUtils', 'socialCommon', 'textCommon', 'thirdPartyAnalytics', 'TimelineMax', 'tpa', 'TweenMax', 'utils', 'warmupUtils', 'warmupUtilsLib', 'tweenEngine', 'wixUiCompsToPackages', 'xss', 'wixCode', 'wix-ui-santa/viewerComponentService.bundle.min', 'santa-site-auth-module', 'zepto'];
      return addConditionalDependencies(clientSidePackages);
    }

    function renderClientSide() {
      var _window$warmupData = window.warmupData,
          warmupData = _window$warmupData === void 0 ? {} : _window$warmupData;
      var clientSidePackages = getClientSidePackages();
      var shouldLoadWorkerDirectly = experiment.isOpen('wixCodeNoIframe') && Boolean(siteModel.publicModel);
      var platformInitPkgs = ['lodash'];

      if (shouldLoadWorkerDirectly) {
        platformInitPkgs = platformInitPkgs.concat(['host-worker-init', 'platformInit']);
      } else {
        platformInitPkgs = platformInitPkgs.concat(['wixCodeInit']);
      }

      loadRequirements(platformInitPkgs, function (_ref4) {
        var _ = _ref4.lodash,
            platformInit = _ref4.platformInit,
            _ref4$wixCodeInit = _ref4.wixCodeInit,
            wixCodeInit = _ref4$wixCodeInit === void 0 ? platformInit : _ref4$wixCodeInit;
        var wixCodeAppApi = wixCodeInit.getAppApi();
        wixCodeInit.initMainR({
          appApi: wixCodeAppApi,
          siteModel: siteModel,
          mobileView: mobileView,
          queryUtil: queryUtil,
          isBot: isBot,
          fetchScripts: true
        });
        var props = {
          wixCodeAppApi: wixCodeAppApi
        };
        wixBiSession.usingPlatform = wixCodeAppApi.isAppInitiated();
        setContext({
          shouldDelay: function shouldDelay() {
            return !isPreview && wixCodeAppApi.isAppInitiated();
          }
        });
        var notify = notifyParent.bind(null, 'santaReady');
        var platformApps = wixCodeInit.appsUtils.getAppsBaseInfo({
          rendererModel: siteModel.rendererModel,
          clientSpecMap: siteModel.rendererModel.clientSpecMap,
          serviceTopology: siteModel.serviceTopology,
          viewerPlatformAppSources: queryUtil.getParameterByName('viewerPlatformAppSources'),
          santaBase: siteModel.santaBase
        });
        var anyPlatformApps = wixCodeInit.specMapUtils.getAppSpec(siteModel.rendererModel.clientSpecMap) || platformApps.length > 0;
        var corePlus = ['core', 'render'];

        if (isQaAutomation) {
          corePlus.push('qaAutomation');
        }

        if (anyPlatformApps) {
          corePlus.push('wixCode');
        }

        if (siteModel.rendererModel.seo) {
          corePlus.push('componentsSeoLayer');
        }

        load(corePlus, function (pkgs, ajaxHandler) {
          performance.mark('prepare start');
          var requireAllComponents = !selectiveCompsDS && (isPreview || useDS || isExternalPreview);
          var core = pkgs.core,
              qaAutomation = pkgs.qaAutomation;

          if (qaAutomation) {
            qaAutomation.init(window, siteModel);
          }

          if (siteModel.rendererModel.seo) {
            clientSidePackages.push('componentsSeoLayer');
          }

          if (requireAllComponents) {
            var packagesNames = [];

            if (experiment.isOpen('sv_appStudioWithBaseUI') && isAppStudioWithDSIntegration) {
              packagesNames.push('wix-ui-santa/baseUIComponentService.bundle');
            }

            requirejs(packagesNames, function (baseUIService) {
              var viewerCompsService = core.viewerCompsService,
                  externalComponentsServicesRegistry = core.externalComponentsServicesRegistry;

              if (baseUIService) {
                externalComponentsServicesRegistry.register(baseUIService);
              }

              viewerCompsService.loadAndRegisterAll(isPreview, {
                runningExperiments: siteModel.rendererModel.runningExperiments
              }).then(function () {
                if (useDS || isPreview || isExternalPreview) {
                  clientSidePackages.push('componentsPreviewLayer');
                }

                loadWithIntegrationPackages(_, clientSidePackages, function (p) {
                  p.render.renderClientSide(p, ajaxHandler, siteModel, props, notify);
                });
              });
            });
          } else if (selectiveCompsDS) {
            siteModel.selectiveCompDownload = true;

            if (useDS || isPreview || isExternalPreview) {
              clientSidePackages.push('componentsPreviewLayer');
            }

            loadWithIntegrationPackages(_, clientSidePackages, function (p) {
              p.render.renderClientSide(p, ajaxHandler, siteModel, props, notify);
            });
          } else {
            siteModel.fixedPagesUrls = warmupData.fixedPagesUrls;
            siteModel.selectiveCompDownload = true;
            var preparedData = pkgs.render.initSiteForRender(siteModel, ajaxHandler, props);
            loadWithIntegrationPackages(_, clientSidePackages, function (p) {
              p.render.renderFromPrepared(p, preparedData.privates, preparedData.prepared, preparedData.props, notify);
            });
          }
        });
      });
      loadRequirements(clientSidePackages);
      prefetchResources(warmupData);
    }

    function renderServerSide() {
      load(['lodash', 'zepto', 'warmupUtilsLib', 'warmupUtils', 'layout', 'wix-ui-santa/dataRefs.bundle', 'image-client-api', 'warmup', 'santa-components-layout'], function (_ref5) {
        var warmup = _ref5.warmup;

        function init() {
          warmup.init(siteModel, function () {
            notifyParent('santaDidLayout');
            renderClientSide();
          });

          if (!window.body) {
            loadRequirements(['core']);
          }
        }

        if (preloadScripts) {
          preloadScripts(['core', 'coreUtils', 'coreUtilsLib', 'tweenEngine', 'reactDOM', 'TweenMax', 'react', 'skins', 'utils', 'componentsCore', 'wix-ui-santa/viewerComponentService.bundle.min', 'santa-components', 'santaProps', 'components', 'santa-data-fixer', 'mobx', 'tpa', 'wixCode', 'platformUtils', 'xss', 'color']);

          if (window.warmupData) {
            prefetchResources(window.warmupData);
          }

          setTimeout(init, 0);
        } else {
          init();
        }
      });
      preconnectAssetsServer();
    } // Server side render state


    window.sssr = {};

    function callRender() {
      if (isServerSide) {
        renderServerSide();
      } else if (window.isServerSideWithHash) {
        document.addEventListener('DOMContentLoaded', function () {
          document.getElementById('SITE_CONTAINER').innerHTML = '';
          renderClientSide();
        });
      } else {
        renderClientSide();
      }

      (0, _miniPackages["default"])(window, requirejs, mobileView, experiment);
    }

    callRender();
  }

  return render;
}
//# sourceMappingURL=render.js.map